import type { ServerColDef } from '@cmg/data-grid';
import { formatters } from '@cmg/data-grid';

import { RolodexRecordStatus } from '../../../../../../../../graphql';
import type { FirmInvestorContactsGridItemFragment } from '../graphql/__generated__';

export const statusColDef: ServerColDef<FirmInvestorContactsGridItemFragment, RolodexRecordStatus> =
  {
    field: 'status',
    headerName: 'Status',
    filter: 'agSetColumnFilter',
    valueFormatter: formatters.enumValueFormatter,
    filterParams: {
      values: Object.values(RolodexRecordStatus),
      valueFormatter: formatters.enumValueFormatter,
    },
  };
